export default __webpack_public_path__ + "static/media/gear.35f36b8b.svg";